import { findFirstNodeByTagName, getFirstNodeInnerHtmlByTagName } from './xml-utils';

export enum MosCommand {
    ncsAck = 'ncsAck',
    ncsReqAppInfo = 'ncsReqAppInfo',
    ncsAppInfo = 'ncsAppInfo',
    ncsReqAppMode = 'ncsReqAppMode',
    ncsStoryRequest = 'ncsStoryRequest',
    ncsItemRequest = 'ncsItemRequest',
    roStorySend = 'roStorySend',
    ncsItem = 'ncsItem',
    mosItemReplace = 'mosItemReplace',
    ncsReqAppClose = 'ncsReqAppClose',
}

export enum MosObjectType {
    VIDEO = 'VIDEO',
    AUDIO = 'AUDIO',
    STILL = 'STILL',
    SUMMARY = 'SUMMARY',
}

export const parseMosMsg = (mosMsg: string): Element => {
    if (!mosMsg) {
        return null;
    }
    if (mosMsg.startsWith('[')) {
        mosMsg = mosMsg.substring(1, mosMsg.length - 1);
    }
    if (mosMsg.endsWith(']')) {
        mosMsg = mosMsg.substring(0, mosMsg.length - 1);
    }
    mosMsg = mosMsg.replace(/\s/g, ' ');

    // TODO: hande 'parsererror' tag in case of invalid xml
    return findFirstNodeByTagName(mosMsg, 'mos');
};

export const getMosCommand = (mosMsg: string): MosCommand => {
    const mosDoc = parseMosMsg(mosMsg);
    let mosCommand = null;
    mosDoc?.childNodes.forEach(node => {
        if (MosCommand[node?.nodeName]) {
            mosCommand = MosCommand[node?.nodeName];
            return;
        }
    });
    return mosCommand;
};

export const ncsAppInfoResponse = (responseParams: {
    mosDeviceId: string;
    userId: string;
    viewPort: {
        x: number;
        y: number;
    };
}): string => {
    const { mosDeviceId, userId, viewPort } = responseParams;
    const { x, y } = viewPort;
    // TODO: generate the info based on the real data
    return `
        <mos>
            <mosID>${mosDeviceId}</mosID>
            <ncsID>3-P</ncsID>
            <ncsAppInfo>
                <ncsInformation>
                    <userID>${userId}</userID>
                    <software>
                        <manufacturer>AP</manufacturer>
                        <product>ENPS Client</product>
                        <version>8</version>
                    </software>
                    <runMode>CONTAINED</runMode>
                    <runContext>EDIT</runContext>
                    <UImetric num="0">
                        <x>${x}</x>
                        <y>${y}</y>
                        <startx>${x}</startx>
                        <starty>${y}</starty>
                        <endx>${x}</endx>
                        <endy>${y}</endy>
                        <mode>CONTAINED</mode>
                    </UImetric>
                </ncsInformation>
            </ncsAppInfo>
        </mos>
    `;
};

export const ncsAckResponse = (): string => {
    return '<mos><ncsAck/></mos>';
};

export const ncsStoryRequestResponse = (): string => {
    // return `<mos><mosID>HTMLCNX</mosID><ncsID>3-P</ncsID><roStorySend><storyID>3-P;P_USV2018\W;0474BFBC-EEB6-4B14-BC7D-CB0DB20A74ED</storyID><storySlug>Za Ned</storySlug><storyNum></storyNum><storyBody><p>BC WED0030 - Farmers Protest VO Tear Gas Engulfs India Farmers Protest</p><p></p><p>2/21/24 04:10</p><p>20240221 - WED0030</p><p>Reuters</p><p>V/O</p><p></p><p></p><p>RESTRICTIONS:</p><p>This material is from? Reuters?and therefore may only be used by CBS affiliates, owned stations, and any others who have agreements with?Reuters. No use after 03/22/2024. Any use beyond thirty days could be subject to penalties.</p><p></p><p>SOURCE: ANI</p><p></p><p>ABSTRACT:</p><p>Thousands of protesting farmers in India were scrambling away from tear gas smoke fired at them by police on Wednesday (February 21), as they sought to resume a march to Delhi after rejecting a government offer on prices for their produce.</p><p></p><p>Fleeing the stinging gas and clouds of smoke, the farmers, some wearing medical masks, ran into the fields surrounding their gathering-point on a highway about 200 km (125 miles) north of New Delhi.</p><p></p><p>Police in riot gear lined both sides of the highway as the farmers, gathering earlier amid morning fog, waved colourful flags emblazoned with the symbols of their unions, while loudspeakers urged them to fight for their rights.</p><p></p><p>The police action came as the government of Prime Minister Narendra Modi made a new offer to resume talks on the farmers&apos; demands. Agriculture Minister Arjun Munda urged the farmers to resolve their grievances through the talks.</p><storyItem><itemID>2</itemID><itemSlug>Man bites dog VO</itemSlug><objID>d04b6d1b-0c99-426f-b6cb-fe9ab5136a2b</objID><mosID>HTMLCNX</mosID><mosAbstract>Man Bites Dog VO :17</mosAbstract><abstract>Man Bites Dog VO :17</abstract><mosPlugInID></mosPlugInID><itemChannel>A</itemChannel><itemEdStart>0</itemEdStart><itemEdDur>510</itemEdDur><itemUserTimingDur>310</itemUserTimingDur><itemTrigger>MANUAL</itemTrigger><macroIn>1;7;5</macroIn><macroOut>2;8;4</macroOut><mosExternalMetadata><mosScope>STORY</mosScope><mosSchema>http://ncsA4.com/mos/supported_schemas/NCSAXML2.08</mosSchema><mosPayload><Owner>PETYA</Owner><ModTime>20010308142001</ModTime><mediaTime>0</mediaTime><TextTime>278</TextTime><ModBy>PETYA</ModBy><Approved>0</Approved><Creator>PETYA</Creator></mosPayload></mosExternalMetadata></storyItem><p></p><storyItem><itemID>3</itemID><itemSlug>Man bites dog VO</itemSlug><objID>5ceb3d01-ba0f-48d5-8f7d-870fededf48b</objID><mosID>HTMLCNX</mosID><mosAbstract>Man Bites Dog VO :17</mosAbstract><abstract>Man Bites Dog VO :17</abstract><mosPlugInID></mosPlugInID><itemChannel>A</itemChannel><itemEdStart>0</itemEdStart><itemEdDur>510</itemEdDur><itemUserTimingDur>310</itemUserTimingDur><itemTrigger>MANUAL</itemTrigger><macroIn>1;7;5</macroIn><macroOut>2;8;4</macroOut><mosExternalMetadata><mosScope>STORY</mosScope><mosSchema>http://ncsA4.com/mos/supported_schemas/NCSAXML2.08</mosSchema><mosPayload><Owner>PETYA</Owner><ModTime>20010308142001</ModTime><mediaTime>0</mediaTime><TextTime>278</TextTime><ModBy>PETYA</ModBy><Approved>0</Approved><Creator>PETYA</Creator></mosPayload></mosExternalMetadata></storyItem><p></p></storyBody><mosExternalMetadata><mosScope>PLAYLIST</mosScope><mosSchema>http://3-P/schema/enps.dtd</mosSchema><mosPayload><Approved>0</Approved><Creator>PETYA</Creator><MediaTime>0</MediaTime><ModBy>PETYA</ModBy><ModTime>2024-02-21T9:15:12</ModTime><Owner>PETYA</Owner><SourceMediaTime>0</SourceMediaTime><SourceTextTime>0</SourceTextTime><TextTime>58</TextTime></mosPayload></mosExternalMetadata></roStorySend></mos>`;
    return `
    <mos>
        <mosID>HTMLCNX</mosID>
        <ncsID>3-P</ncsID>
        <roStorySend>
            <storyID>3-P;P_USV2018\W;0474BFBC-EEB6-4B14-BC7D-CB0DB20A74ED</storyID>
            <storySlug>Za Ned</storySlug>
            <storyNum></storyNum>
            <storyBody>
                <p>BC WED0030 - Farmers Protest VO Tear Gas Engulfs India Farmers Protest</p>
                <p></p>
                <p>2/21/24 04:10</p>
                <p>20240221 - WED0030</p>
                <p>Reuters</p>
                <p>V/O</p>
                <p></p>
                <p></p>
                <p>RESTRICTIONS:</p>
                <p>This material is from? Reuters?and therefore may only be used by CBS affiliates, owned stations, and any others who have agreements with?Reuters. No use after 03/22/2024. Any use beyond thirty days could be subject to penalties.</p>
                <p></p>
                <p>SOURCE: ANI</p>
                <p></p>
                <p>ABSTRACT:</p>
                <p>Thousands of protesting farmers in India were scrambling away from tear gas smoke fired at them by police on Wednesday (February 21), as they sought to resume a march to Delhi after rejecting a government offer on prices for their produce.</p>
                <p></p>
                <p>Fleeing the stinging gas and clouds of smoke, the farmers, some wearing medical masks, ran into the fields surrounding their gathering-point on a highway about 200 km (125 miles) north of New Delhi.</p>
                <p></p>
                <p>Police in riot gear lined both sides of the highway as the farmers, gathering earlier amid morning fog, waved colourful flags emblazoned with the symbols of their unions, while loudspeakers urged them to fight for their rights.</p>
                <p></p>
                <p>The police action came as the government of Prime Minister Narendra Modi made a new offer to resume talks on the farmers&apos; demands. Agriculture Minister Arjun Munda urged the farmers to resolve their grievances through the talks.</p>
                <storyItem>
                    <itemID>2</itemID>
                    <itemSlug>Man bites dog VO</itemSlug>
                    <objID>d04b6d1b-0c99-426f-b6cb-fe9ab5136a2b</objID>
                    <mosID>HTMLCNX</mosID>
                    <mosAbstract>Man Bites Dog VO :17</mosAbstract>
                    <abstract>Man Bites Dog VO :17</abstract>
                    <mosPlugInID></mosPlugInID>
                    <itemChannel>A</itemChannel>
                    <itemEdStart>0</itemEdStart>
                    <itemEdDur>510</itemEdDur>
                    <itemUserTimingDur>310</itemUserTimingDur>
                    <itemTrigger>MANUAL</itemTrigger>
                    <macroIn>1;7;5</macroIn>
                    <macroOut>2;8;4</macroOut>
                    <mosExternalMetadata>
                        <mosScope>STORY</mosScope>
                        <mosSchema>http://ncsA4.com/mos/supported_schemas/NCSAXML2.08</mosSchema>
                        <mosPayload>
                            <Owner>PETYA</Owner>
                            <ModTime>20010308142001</ModTime>
                            <mediaTime>0</mediaTime>
                            <TextTime>278</TextTime>
                            <ModBy>PETYA</ModBy>
                            <Approved>0</Approved>
                            <Creator>PETYA</Creator>
                        </mosPayload>
                    </mosExternalMetadata>
                </storyItem>
                <p></p>
                <storyItem>
                    <itemID>3</itemID>
                    <itemSlug>Man bites dog VO</itemSlug>
                    <objID>5ceb3d01-ba0f-48d5-8f7d-870fededf48b</objID>
                    <mosID>HTMLCNX</mosID>
                    <mosAbstract>Man Bites Dog VO :17</mosAbstract>
                    <abstract>Man Bites Dog VO :17</abstract>
                    <mosPlugInID></mosPlugInID>
                    <itemChannel>A</itemChannel>
                    <itemEdStart>0</itemEdStart>
                    <itemEdDur>510</itemEdDur>
                    <itemUserTimingDur>310</itemUserTimingDur>
                    <itemTrigger>MANUAL</itemTrigger>
                    <macroIn>1;7;5</macroIn>
                    <macroOut>2;8;4</macroOut>
                    <mosExternalMetadata>
                        <mosScope>STORY</mosScope>
                        <mosSchema>http://ncsA4.com/mos/supported_schemas/NCSAXML2.08</mosSchema>
                        <mosPayload>
                            <Owner>PETYA</Owner>
                            <ModTime>20010308142001</ModTime>
                            <mediaTime>0</mediaTime>
                            <TextTime>278</TextTime>
                            <ModBy>PETYA</ModBy>
                            <Approved>0</Approved>
                            <Creator>PETYA</Creator>
                        </mosPayload>
                    </mosExternalMetadata>
                </storyItem>
                <p></p>
            </storyBody>
            <mosExternalMetadata>
                <mosScope>PLAYLIST</mosScope>
                <mosSchema>http://3-P/schema/enps.dtd</mosSchema>
                <mosPayload>
                    <Approved>0</Approved>
                    <Creator>PETYA</Creator>
                    <MediaTime>0</MediaTime>
                    <ModBy>PETYA</ModBy>
                    <ModTime>2024-02-21T9:15:12</ModTime>
                    <Owner>PETYA</Owner>
                    <SourceMediaTime>0</SourceMediaTime>
                    <SourceTextTime>0</SourceTextTime>
                    <TextTime>58</TextTime>
                </mosPayload>
            </mosExternalMetadata>
        </roStorySend>
    </mos>
    `;
};

export const ncsItemRequestNotFoundResponse = (): string => {
    return `
    <mos>
        <ncsAck>
            <status>ERROR</status>
            <statusDescription>Current MOS Item Reference not found</statusDescription>
        </ncsAck>
    </mos>
    `;
};

export const ncsItemRequestResponse = (mosObj: string): string => {
    const mosItem = parseMosMsg(mosObj);
    if (mosItem) {
        return `<mos><ncsItem><item>${mosItem.innerHTML}</item></ncsItem></mos>`;
    }
    return '';
};

export const convertMosItemFromPlugin = (mosItem: string): string => {
    if (!mosItem) {
        return '';
    }
    return `<mos>${getFirstNodeInnerHtmlByTagName(mosItem, 'item')}</mos>`;
};
